function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFilm = function SvgIconFilm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 350.821 323.982"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M119.547 377.563v-43.461h53.683l-.022 43.118h137.598l-.014-43.118h53.682l-.033 43.118h39.487s.029-241.237 0-350.383c0 0-30.099.326-39.487 0l.033 43.083h-53.682l.014-43.083s-100.834.003-137.598 0l.022 43.083h-53.683V26.837s-25.106-.214-39.588 0c0 0 .19 241.461.26 350.726zm191.246-255.371h53.682v53.684h-53.682zm0 105.954h53.682v53.684h-53.682ZM119.547 122.192h53.683v53.684h-53.683zm0 105.954h53.683v53.684h-53.683z",
    style: {
      fill: "#fff"
    },
    transform: "rotate(90 228.76 148.802)"
  }));
};
export default SvgIconFilm;